import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザの個人情報を取得する
 *
 * @param {Number} uid ユーザID
 * @returns {Response} レスポンスデータ
 */
export function getUserProfile (uid) {
  return request.get(`/users/${uid}/profile`, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
